import { jsx as i, jsxs as te, Fragment as Te } from "react/jsx-runtime";
import * as t from "react";
import * as Ee from "react-dom";
import { c as ct, a as N, d as z, u as Pe } from "../../index-DcwNtM_b.js";
import { c as it, u as dt } from "../../index-TA5H0I__.js";
import { u as k, c as ut } from "../../index-5Bhkapwi.js";
import { P as pt, D as ft } from "../../index-C1kx85Np.js";
import { h as mt, u as ht, R as vt, F as gt } from "../../Combination-CmNnuUVg.js";
import { u as be } from "../../index-CDznMoQN.js";
import { c as _e, A as St, C as wt, R as xt, a as Ct } from "../../index-Bebf-Vfp.js";
import { P as M } from "../../index-CpDnqHCm.js";
import { u as yt } from "../../index-0ioNhtNM.js";
import { u as It } from "../../index-BZPx6jYI.js";
import { V as Tt } from "../../index-DfNPZZ8M.js";
import { c as oe } from "../../utils-BOFVZgHd.js";
import { C as bt } from "../../chevron-down-DbW0ZdOK.js";
import { C as Nt } from "../../check-B9pOV8LL.js";
function Re(o, [n, e]) {
  return Math.min(e, Math.max(n, o));
}
var Pt = [" ", "Enter", "ArrowUp", "ArrowDown"], Rt = [" ", "Enter"], J = "Select", [de, ue, Et] = it(J), [ne, To] = ct(J, [
  Et,
  _e
]), pe = _e(), [_t, j] = ne(J), [Mt, At] = ne(J), Me = (o) => {
  const {
    __scopeSelect: n,
    children: e,
    open: a,
    defaultOpen: s,
    onOpenChange: u,
    value: r,
    defaultValue: l,
    onValueChange: c,
    dir: f,
    name: g,
    autoComplete: x,
    disabled: P,
    required: T,
    form: y
  } = o, d = pe(n), [h, S] = t.useState(null), [m, v] = t.useState(null), [U, A] = t.useState(!1), re = dt(f), [R, D] = Pe({
    prop: a,
    defaultProp: s ?? !1,
    onChange: u,
    caller: J
  }), [K, q] = Pe({
    prop: r,
    defaultProp: l,
    onChange: c,
    caller: J
  }), V = t.useRef(null), B = h ? y || !!h.closest("form") : !0, [G, H] = t.useState(/* @__PURE__ */ new Set()), F = Array.from(G).map((E) => E.props.value).join(";");
  return /* @__PURE__ */ i(xt, { ...d, children: /* @__PURE__ */ te(
    _t,
    {
      required: T,
      scope: n,
      trigger: h,
      onTriggerChange: S,
      valueNode: m,
      onValueNodeChange: v,
      valueNodeHasChildren: U,
      onValueNodeHasChildrenChange: A,
      contentId: be(),
      value: K,
      onValueChange: q,
      open: R,
      onOpenChange: D,
      dir: re,
      triggerPointerDownPosRef: V,
      disabled: P,
      children: [
        /* @__PURE__ */ i(de.Provider, { scope: n, children: /* @__PURE__ */ i(
          Mt,
          {
            scope: o.__scopeSelect,
            onNativeOptionAdd: t.useCallback((E) => {
              H((L) => new Set(L).add(E));
            }, []),
            onNativeOptionRemove: t.useCallback((E) => {
              H((L) => {
                const W = new Set(L);
                return W.delete(E), W;
              });
            }, []),
            children: e
          }
        ) }),
        B ? /* @__PURE__ */ te(
          Qe,
          {
            "aria-hidden": !0,
            required: T,
            tabIndex: -1,
            name: g,
            autoComplete: x,
            value: K,
            onChange: (E) => q(E.target.value),
            disabled: P,
            form: y,
            children: [
              K === void 0 ? /* @__PURE__ */ i("option", { value: "" }) : null,
              Array.from(G)
            ]
          },
          F
        ) : null
      ]
    }
  ) });
};
Me.displayName = J;
var Ae = "SelectTrigger", Oe = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, disabled: a = !1, ...s } = o, u = pe(e), r = j(Ae, e), l = r.disabled || a, c = k(n, r.onTriggerChange), f = ue(e), g = t.useRef("touch"), [x, P, T] = tt((d) => {
      const h = f().filter((v) => !v.disabled), S = h.find((v) => v.value === r.value), m = ot(h, d, S);
      m !== void 0 && r.onValueChange(m.value);
    }), y = (d) => {
      l || (r.onOpenChange(!0), T()), d && (r.triggerPointerDownPosRef.current = {
        x: Math.round(d.pageX),
        y: Math.round(d.pageY)
      });
    };
    return /* @__PURE__ */ i(St, { asChild: !0, ...u, children: /* @__PURE__ */ i(
      M.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": r.contentId,
        "aria-expanded": r.open,
        "aria-required": r.required,
        "aria-autocomplete": "none",
        dir: r.dir,
        "data-state": r.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": et(r.value) ? "" : void 0,
        ...s,
        ref: c,
        onClick: N(s.onClick, (d) => {
          d.currentTarget.focus(), g.current !== "mouse" && y(d);
        }),
        onPointerDown: N(s.onPointerDown, (d) => {
          g.current = d.pointerType;
          const h = d.target;
          h.hasPointerCapture(d.pointerId) && h.releasePointerCapture(d.pointerId), d.button === 0 && d.ctrlKey === !1 && d.pointerType === "mouse" && (y(d), d.preventDefault());
        }),
        onKeyDown: N(s.onKeyDown, (d) => {
          const h = x.current !== "";
          !(d.ctrlKey || d.altKey || d.metaKey) && d.key.length === 1 && P(d.key), !(h && d.key === " ") && Pt.includes(d.key) && (y(), d.preventDefault());
        })
      }
    ) });
  }
);
Oe.displayName = Ae;
var De = "SelectValue", Le = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, className: a, style: s, children: u, placeholder: r = "", ...l } = o, c = j(De, e), { onValueNodeHasChildrenChange: f } = c, g = u !== void 0, x = k(n, c.onValueNodeChange);
    return z(() => {
      f(g);
    }, [f, g]), /* @__PURE__ */ i(
      M.span,
      {
        ...l,
        ref: x,
        style: { pointerEvents: "none" },
        children: et(c.value) ? /* @__PURE__ */ i(Te, { children: r }) : u
      }
    );
  }
);
Le.displayName = De;
var Ot = "SelectIcon", Dt = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, children: a, ...s } = o;
    return /* @__PURE__ */ i(M.span, { "aria-hidden": !0, ...s, ref: n, children: a || "▼" });
  }
);
Dt.displayName = Ot;
var Lt = "SelectPortal", ke = (o) => /* @__PURE__ */ i(pt, { asChild: !0, ...o });
ke.displayName = Lt;
var Q = "SelectContent", Ve = t.forwardRef(
  (o, n) => {
    const e = j(Q, o.__scopeSelect), [a, s] = t.useState();
    if (z(() => {
      s(new DocumentFragment());
    }, []), !e.open) {
      const u = a;
      return u ? Ee.createPortal(
        /* @__PURE__ */ i(Be, { scope: o.__scopeSelect, children: /* @__PURE__ */ i(de.Slot, { scope: o.__scopeSelect, children: /* @__PURE__ */ i("div", { children: o.children }) }) }),
        u
      ) : null;
    }
    return /* @__PURE__ */ i(He, { ...o, ref: n });
  }
);
Ve.displayName = Q;
var O = 10, [Be, Y] = ne(Q), kt = "SelectContentImpl", Vt = ut("SelectContent.RemoveScroll"), He = t.forwardRef(
  (o, n) => {
    const {
      __scopeSelect: e,
      position: a = "item-aligned",
      onCloseAutoFocus: s,
      onEscapeKeyDown: u,
      onPointerDownOutside: r,
      //
      // PopperContent props
      side: l,
      sideOffset: c,
      align: f,
      alignOffset: g,
      arrowPadding: x,
      collisionBoundary: P,
      collisionPadding: T,
      sticky: y,
      hideWhenDetached: d,
      avoidCollisions: h,
      //
      ...S
    } = o, m = j(Q, e), [v, U] = t.useState(null), [A, re] = t.useState(null), R = k(n, (p) => U(p)), [D, K] = t.useState(null), [q, V] = t.useState(
      null
    ), B = ue(e), [G, H] = t.useState(!1), F = t.useRef(!1);
    t.useEffect(() => {
      if (v) return mt(v);
    }, [v]), ht();
    const E = t.useCallback(
      (p) => {
        const [I, ..._] = B().map((b) => b.ref.current), [w] = _.slice(-1), C = document.activeElement;
        for (const b of p)
          if (b === C || (b?.scrollIntoView({ block: "nearest" }), b === I && A && (A.scrollTop = 0), b === w && A && (A.scrollTop = A.scrollHeight), b?.focus(), document.activeElement !== C)) return;
      },
      [B, A]
    ), L = t.useCallback(
      () => E([D, v]),
      [E, D, v]
    );
    t.useEffect(() => {
      G && L();
    }, [G, L]);
    const { onOpenChange: W, triggerPointerDownPosRef: $ } = m;
    t.useEffect(() => {
      if (v) {
        let p = { x: 0, y: 0 };
        const I = (w) => {
          p = {
            x: Math.abs(Math.round(w.pageX) - ($.current?.x ?? 0)),
            y: Math.abs(Math.round(w.pageY) - ($.current?.y ?? 0))
          };
        }, _ = (w) => {
          p.x <= 10 && p.y <= 10 ? w.preventDefault() : v.contains(w.target) || W(!1), document.removeEventListener("pointermove", I), $.current = null;
        };
        return $.current !== null && (document.addEventListener("pointermove", I), document.addEventListener("pointerup", _, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", I), document.removeEventListener("pointerup", _, { capture: !0 });
        };
      }
    }, [v, W, $]), t.useEffect(() => {
      const p = () => W(!1);
      return window.addEventListener("blur", p), window.addEventListener("resize", p), () => {
        window.removeEventListener("blur", p), window.removeEventListener("resize", p);
      };
    }, [W]);
    const [fe, le] = tt((p) => {
      const I = B().filter((C) => !C.disabled), _ = I.find((C) => C.ref.current === document.activeElement), w = ot(I, p, _);
      w && setTimeout(() => w.ref.current.focus());
    }), me = t.useCallback(
      (p, I, _) => {
        const w = !F.current && !_;
        (m.value !== void 0 && m.value === I || w) && (K(p), w && (F.current = !0));
      },
      [m.value]
    ), he = t.useCallback(() => v?.focus(), [v]), ee = t.useCallback(
      (p, I, _) => {
        const w = !F.current && !_;
        (m.value !== void 0 && m.value === I || w) && V(p);
      },
      [m.value]
    ), ce = a === "popper" ? we : Fe, se = ce === we ? {
      side: l,
      sideOffset: c,
      align: f,
      alignOffset: g,
      arrowPadding: x,
      collisionBoundary: P,
      collisionPadding: T,
      sticky: y,
      hideWhenDetached: d,
      avoidCollisions: h
    } : {};
    return /* @__PURE__ */ i(
      Be,
      {
        scope: e,
        content: v,
        viewport: A,
        onViewportChange: re,
        itemRefCallback: me,
        selectedItem: D,
        onItemLeave: he,
        itemTextRefCallback: ee,
        focusSelectedItem: L,
        selectedItemText: q,
        position: a,
        isPositioned: G,
        searchRef: fe,
        children: /* @__PURE__ */ i(vt, { as: Vt, allowPinchZoom: !0, children: /* @__PURE__ */ i(
          gt,
          {
            asChild: !0,
            trapped: m.open,
            onMountAutoFocus: (p) => {
              p.preventDefault();
            },
            onUnmountAutoFocus: N(s, (p) => {
              m.trigger?.focus({ preventScroll: !0 }), p.preventDefault();
            }),
            children: /* @__PURE__ */ i(
              ft,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: u,
                onPointerDownOutside: r,
                onFocusOutside: (p) => p.preventDefault(),
                onDismiss: () => m.onOpenChange(!1),
                children: /* @__PURE__ */ i(
                  ce,
                  {
                    role: "listbox",
                    id: m.contentId,
                    "data-state": m.open ? "open" : "closed",
                    dir: m.dir,
                    onContextMenu: (p) => p.preventDefault(),
                    ...S,
                    ...se,
                    onPlaced: () => H(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...S.style
                    },
                    onKeyDown: N(S.onKeyDown, (p) => {
                      const I = p.ctrlKey || p.altKey || p.metaKey;
                      if (p.key === "Tab" && p.preventDefault(), !I && p.key.length === 1 && le(p.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(p.key)) {
                        let w = B().filter((C) => !C.disabled).map((C) => C.ref.current);
                        if (["ArrowUp", "End"].includes(p.key) && (w = w.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(p.key)) {
                          const C = p.target, b = w.indexOf(C);
                          w = w.slice(b + 1);
                        }
                        setTimeout(() => E(w)), p.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
He.displayName = kt;
var Bt = "SelectItemAlignedPosition", Fe = t.forwardRef((o, n) => {
  const { __scopeSelect: e, onPlaced: a, ...s } = o, u = j(Q, e), r = Y(Q, e), [l, c] = t.useState(null), [f, g] = t.useState(null), x = k(n, (R) => g(R)), P = ue(e), T = t.useRef(!1), y = t.useRef(!0), { viewport: d, selectedItem: h, selectedItemText: S, focusSelectedItem: m } = r, v = t.useCallback(() => {
    if (u.trigger && u.valueNode && l && f && d && h && S) {
      const R = u.trigger.getBoundingClientRect(), D = f.getBoundingClientRect(), K = u.valueNode.getBoundingClientRect(), q = S.getBoundingClientRect();
      if (u.dir !== "rtl") {
        const C = q.left - D.left, b = K.left - C, X = R.left - b, Z = R.width + X, ve = Math.max(Z, D.width), ge = window.innerWidth - O, Se = Re(b, [
          O,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(O, ge - ve)
        ]);
        l.style.minWidth = Z + "px", l.style.left = Se + "px";
      } else {
        const C = D.right - q.right, b = window.innerWidth - K.right - C, X = window.innerWidth - R.right - b, Z = R.width + X, ve = Math.max(Z, D.width), ge = window.innerWidth - O, Se = Re(b, [
          O,
          Math.max(O, ge - ve)
        ]);
        l.style.minWidth = Z + "px", l.style.right = Se + "px";
      }
      const V = P(), B = window.innerHeight - O * 2, G = d.scrollHeight, H = window.getComputedStyle(f), F = parseInt(H.borderTopWidth, 10), E = parseInt(H.paddingTop, 10), L = parseInt(H.borderBottomWidth, 10), W = parseInt(H.paddingBottom, 10), $ = F + E + G + W + L, fe = Math.min(h.offsetHeight * 5, $), le = window.getComputedStyle(d), me = parseInt(le.paddingTop, 10), he = parseInt(le.paddingBottom, 10), ee = R.top + R.height / 2 - O, ce = B - ee, se = h.offsetHeight / 2, p = h.offsetTop + se, I = F + E + p, _ = $ - I;
      if (I <= ee) {
        const C = V.length > 0 && h === V[V.length - 1].ref.current;
        l.style.bottom = "0px";
        const b = f.clientHeight - d.offsetTop - d.offsetHeight, X = Math.max(
          ce,
          se + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (C ? he : 0) + b + L
        ), Z = I + X;
        l.style.height = Z + "px";
      } else {
        const C = V.length > 0 && h === V[0].ref.current;
        l.style.top = "0px";
        const X = Math.max(
          ee,
          F + d.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (C ? me : 0) + se
        ) + _;
        l.style.height = X + "px", d.scrollTop = I - ee + d.offsetTop;
      }
      l.style.margin = `${O}px 0`, l.style.minHeight = fe + "px", l.style.maxHeight = B + "px", a?.(), requestAnimationFrame(() => T.current = !0);
    }
  }, [
    P,
    u.trigger,
    u.valueNode,
    l,
    f,
    d,
    h,
    S,
    u.dir,
    a
  ]);
  z(() => v(), [v]);
  const [U, A] = t.useState();
  z(() => {
    f && A(window.getComputedStyle(f).zIndex);
  }, [f]);
  const re = t.useCallback(
    (R) => {
      R && y.current === !0 && (v(), m?.(), y.current = !1);
    },
    [v, m]
  );
  return /* @__PURE__ */ i(
    Ft,
    {
      scope: e,
      contentWrapper: l,
      shouldExpandOnScrollRef: T,
      onScrollButtonChange: re,
      children: /* @__PURE__ */ i(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: U
          },
          children: /* @__PURE__ */ i(
            M.div,
            {
              ...s,
              ref: x,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...s.style
              }
            }
          )
        }
      )
    }
  );
});
Fe.displayName = Bt;
var Ht = "SelectPopperPosition", we = t.forwardRef((o, n) => {
  const {
    __scopeSelect: e,
    align: a = "start",
    collisionPadding: s = O,
    ...u
  } = o, r = pe(e);
  return /* @__PURE__ */ i(
    wt,
    {
      ...r,
      ...u,
      ref: n,
      align: a,
      collisionPadding: s,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...u.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
we.displayName = Ht;
var [Ft, Ne] = ne(Q, {}), xe = "SelectViewport", We = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, nonce: a, ...s } = o, u = Y(xe, e), r = Ne(xe, e), l = k(n, u.onViewportChange), c = t.useRef(0);
    return /* @__PURE__ */ te(Te, { children: [
      /* @__PURE__ */ i(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: a
        }
      ),
      /* @__PURE__ */ i(de.Slot, { scope: e, children: /* @__PURE__ */ i(
        M.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...s,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...s.style
          },
          onScroll: N(s.onScroll, (f) => {
            const g = f.currentTarget, { contentWrapper: x, shouldExpandOnScrollRef: P } = r;
            if (P?.current && x) {
              const T = Math.abs(c.current - g.scrollTop);
              if (T > 0) {
                const y = window.innerHeight - O * 2, d = parseFloat(x.style.minHeight), h = parseFloat(x.style.height), S = Math.max(d, h);
                if (S < y) {
                  const m = S + T, v = Math.min(y, m), U = m - v;
                  x.style.height = v + "px", x.style.bottom === "0px" && (g.scrollTop = U > 0 ? U : 0, x.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = g.scrollTop;
          })
        }
      ) })
    ] });
  }
);
We.displayName = xe;
var Ue = "SelectGroup", [Wt, Ut] = ne(Ue), Ke = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, ...a } = o, s = be();
    return /* @__PURE__ */ i(Wt, { scope: e, id: s, children: /* @__PURE__ */ i(M.div, { role: "group", "aria-labelledby": s, ...a, ref: n }) });
  }
);
Ke.displayName = Ue;
var Ge = "SelectLabel", $e = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, ...a } = o, s = Ut(Ge, e);
    return /* @__PURE__ */ i(M.div, { id: s.id, ...a, ref: n });
  }
);
$e.displayName = Ge;
var ie = "SelectItem", [Kt, ze] = ne(ie), je = t.forwardRef(
  (o, n) => {
    const {
      __scopeSelect: e,
      value: a,
      disabled: s = !1,
      textValue: u,
      ...r
    } = o, l = j(ie, e), c = Y(ie, e), f = l.value === a, [g, x] = t.useState(u ?? ""), [P, T] = t.useState(!1), y = k(
      n,
      (m) => c.itemRefCallback?.(m, a, s)
    ), d = be(), h = t.useRef("touch"), S = () => {
      s || (l.onValueChange(a), l.onOpenChange(!1));
    };
    if (a === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ i(
      Kt,
      {
        scope: e,
        value: a,
        disabled: s,
        textId: d,
        isSelected: f,
        onItemTextChange: t.useCallback((m) => {
          x((v) => v || (m?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ i(
          de.ItemSlot,
          {
            scope: e,
            value: a,
            disabled: s,
            textValue: g,
            children: /* @__PURE__ */ i(
              M.div,
              {
                role: "option",
                "aria-labelledby": d,
                "data-highlighted": P ? "" : void 0,
                "aria-selected": f && P,
                "data-state": f ? "checked" : "unchecked",
                "aria-disabled": s || void 0,
                "data-disabled": s ? "" : void 0,
                tabIndex: s ? void 0 : -1,
                ...r,
                ref: y,
                onFocus: N(r.onFocus, () => T(!0)),
                onBlur: N(r.onBlur, () => T(!1)),
                onClick: N(r.onClick, () => {
                  h.current !== "mouse" && S();
                }),
                onPointerUp: N(r.onPointerUp, () => {
                  h.current === "mouse" && S();
                }),
                onPointerDown: N(r.onPointerDown, (m) => {
                  h.current = m.pointerType;
                }),
                onPointerMove: N(r.onPointerMove, (m) => {
                  h.current = m.pointerType, s ? c.onItemLeave?.() : h.current === "mouse" && m.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: N(r.onPointerLeave, (m) => {
                  m.currentTarget === document.activeElement && c.onItemLeave?.();
                }),
                onKeyDown: N(r.onKeyDown, (m) => {
                  c.searchRef?.current !== "" && m.key === " " || (Rt.includes(m.key) && S(), m.key === " " && m.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
je.displayName = ie;
var ae = "SelectItemText", Ye = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, className: a, style: s, ...u } = o, r = j(ae, e), l = Y(ae, e), c = ze(ae, e), f = At(ae, e), [g, x] = t.useState(null), P = k(
      n,
      (S) => x(S),
      c.onItemTextChange,
      (S) => l.itemTextRefCallback?.(S, c.value, c.disabled)
    ), T = g?.textContent, y = t.useMemo(
      () => /* @__PURE__ */ i("option", { value: c.value, disabled: c.disabled, children: T }, c.value),
      [c.disabled, c.value, T]
    ), { onNativeOptionAdd: d, onNativeOptionRemove: h } = f;
    return z(() => (d(y), () => h(y)), [d, h, y]), /* @__PURE__ */ te(Te, { children: [
      /* @__PURE__ */ i(M.span, { id: c.textId, ...u, ref: P }),
      c.isSelected && r.valueNode && !r.valueNodeHasChildren ? Ee.createPortal(u.children, r.valueNode) : null
    ] });
  }
);
Ye.displayName = ae;
var qe = "SelectItemIndicator", Xe = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, ...a } = o;
    return ze(qe, e).isSelected ? /* @__PURE__ */ i(M.span, { "aria-hidden": !0, ...a, ref: n }) : null;
  }
);
Xe.displayName = qe;
var Ce = "SelectScrollUpButton", Gt = t.forwardRef((o, n) => {
  const e = Y(Ce, o.__scopeSelect), a = Ne(Ce, o.__scopeSelect), [s, u] = t.useState(!1), r = k(n, a.onScrollButtonChange);
  return z(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = c.scrollTop > 0;
        u(f);
      };
      const c = e.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), s ? /* @__PURE__ */ i(
    Ze,
    {
      ...o,
      ref: r,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = e;
        l && c && (l.scrollTop = l.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
Gt.displayName = Ce;
var ye = "SelectScrollDownButton", $t = t.forwardRef((o, n) => {
  const e = Y(ye, o.__scopeSelect), a = Ne(ye, o.__scopeSelect), [s, u] = t.useState(!1), r = k(n, a.onScrollButtonChange);
  return z(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = c.scrollHeight - c.clientHeight, g = Math.ceil(c.scrollTop) < f;
        u(g);
      };
      const c = e.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), s ? /* @__PURE__ */ i(
    Ze,
    {
      ...o,
      ref: r,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = e;
        l && c && (l.scrollTop = l.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
$t.displayName = ye;
var Ze = t.forwardRef((o, n) => {
  const { __scopeSelect: e, onAutoScroll: a, ...s } = o, u = Y("SelectScrollButton", e), r = t.useRef(null), l = ue(e), c = t.useCallback(() => {
    r.current !== null && (window.clearInterval(r.current), r.current = null);
  }, []);
  return t.useEffect(() => () => c(), [c]), z(() => {
    l().find((g) => g.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ i(
    M.div,
    {
      "aria-hidden": !0,
      ...s,
      ref: n,
      style: { flexShrink: 0, ...s.style },
      onPointerDown: N(s.onPointerDown, () => {
        r.current === null && (r.current = window.setInterval(a, 50));
      }),
      onPointerMove: N(s.onPointerMove, () => {
        u.onItemLeave?.(), r.current === null && (r.current = window.setInterval(a, 50));
      }),
      onPointerLeave: N(s.onPointerLeave, () => {
        c();
      })
    }
  );
}), zt = "SelectSeparator", Je = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, ...a } = o;
    return /* @__PURE__ */ i(M.div, { "aria-hidden": !0, ...a, ref: n });
  }
);
Je.displayName = zt;
var Ie = "SelectArrow", jt = t.forwardRef(
  (o, n) => {
    const { __scopeSelect: e, ...a } = o, s = pe(e), u = j(Ie, e), r = Y(Ie, e);
    return u.open && r.position === "popper" ? /* @__PURE__ */ i(Ct, { ...s, ...a, ref: n }) : null;
  }
);
jt.displayName = Ie;
var Yt = "SelectBubbleInput", Qe = t.forwardRef(
  ({ __scopeSelect: o, value: n, ...e }, a) => {
    const s = t.useRef(null), u = k(a, s), r = It(n);
    return t.useEffect(() => {
      const l = s.current;
      if (!l) return;
      const c = window.HTMLSelectElement.prototype, g = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (r !== n && g) {
        const x = new Event("change", { bubbles: !0 });
        g.call(l, n), l.dispatchEvent(x);
      }
    }, [r, n]), /* @__PURE__ */ i(
      M.select,
      {
        ...e,
        style: { ...Tt, ...e.style },
        ref: u,
        defaultValue: n
      }
    );
  }
);
Qe.displayName = Yt;
function et(o) {
  return o === "" || o === void 0;
}
function tt(o) {
  const n = yt(o), e = t.useRef(""), a = t.useRef(0), s = t.useCallback(
    (r) => {
      const l = e.current + r;
      n(l), function c(f) {
        e.current = f, window.clearTimeout(a.current), f !== "" && (a.current = window.setTimeout(() => c(""), 1e3));
      }(l);
    },
    [n]
  ), u = t.useCallback(() => {
    e.current = "", window.clearTimeout(a.current);
  }, []);
  return t.useEffect(() => () => window.clearTimeout(a.current), []), [e, s, u];
}
function ot(o, n, e) {
  const s = n.length > 1 && Array.from(n).every((f) => f === n[0]) ? n[0] : n, u = e ? o.indexOf(e) : -1;
  let r = qt(o, Math.max(u, 0));
  s.length === 1 && (r = r.filter((f) => f !== e));
  const c = r.find(
    (f) => f.textValue.toLowerCase().startsWith(s.toLowerCase())
  );
  return c !== e ? c : void 0;
}
function qt(o, n) {
  return o.map((e, a) => o[(n + a) % o.length]);
}
var Xt = Me, nt = Oe, Zt = Le, Jt = ke, rt = Ve, Qt = We, eo = Ke, st = $e, at = je, to = Ye, oo = Xe, lt = Je;
const bo = Xt, No = eo, Po = Zt, no = t.forwardRef(({ className: o, children: n, ...e }, a) => /* @__PURE__ */ te(
  nt,
  {
    ref: a,
    className: oe(
      "flex h-10 w-full items-center justify-between rounded-sm px-3 py-2 text-sm",
      "bg-[var(--input)] text-[var(--foreground)] placeholder:text-[var(--muted-foreground)]",
      "border border-[var(--border)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "transition-colors duration-200",
      o
    ),
    ...e,
    children: [
      n,
      /* @__PURE__ */ i(bt, { className: "h-4 w-4 opacity-70" })
    ]
  }
));
no.displayName = nt.displayName;
const ro = t.forwardRef(({ className: o, children: n, position: e = "popper", ...a }, s) => /* @__PURE__ */ i(Jt, { children: /* @__PURE__ */ i(
  rt,
  {
    ref: s,
    className: oe(
      "relative z-50 min-w-[8rem] overflow-hidden rounded-sm shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      "data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
      "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      "bg-[var(--popover)] text-[var(--popover-foreground)]",
      "border border-[var(--border)]",
      e === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      o
    ),
    position: e,
    ...a,
    children: /* @__PURE__ */ i(
      Qt,
      {
        className: oe(
          "p-1",
          e === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: n
      }
    )
  }
) }));
ro.displayName = rt.displayName;
const so = t.forwardRef(({ className: o, ...n }, e) => /* @__PURE__ */ i(
  st,
  {
    ref: e,
    className: oe("px-2 py-1.5 text-sm font-semibold", o),
    ...n
  }
));
so.displayName = st.displayName;
const ao = t.forwardRef(({ className: o, children: n, ...e }, a) => /* @__PURE__ */ te(
  at,
  {
    ref: a,
    className: oe(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none",
      "focus:bg-[var(--accent)] focus:text-[var(--accent-foreground)]",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "transition-colors duration-200",
      o
    ),
    ...e,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ i(oo, { children: /* @__PURE__ */ i(Nt, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ i(to, { children: n })
    ]
  }
));
ao.displayName = at.displayName;
const lo = t.forwardRef(({ className: o, ...n }, e) => /* @__PURE__ */ i(
  lt,
  {
    ref: e,
    className: oe("h-px -mx-1 my-1 bg-[var(--muted-foreground)]/20", o),
    ...n
  }
));
lo.displayName = lt.displayName;
export {
  bo as Select,
  ro as SelectContent,
  No as SelectGroup,
  ao as SelectItem,
  so as SelectLabel,
  lo as SelectSeparator,
  no as SelectTrigger,
  Po as SelectValue
};
//# sourceMappingURL=select.js.map
